"use strict";
exports.__esModule = true;
var utils_1 = require("../utils");
var exceptions_1 = require("../exceptions");
function defaultShowAction(touches) {
    var document = window.document;
    var body = document.body;
    var fragment = document.createDocumentFragment();
    touches.forEach(function (touch) {
        var touchSignal = document.createElement("div");
        touchSignal.style.zIndex = "2000";
        touchSignal.style.background = "red";
        touchSignal.style.borderRadius = "50%";
        touchSignal.style.width = "20px";
        touchSignal.style.height = "20px";
        touchSignal.style.position = "absolute";
        touchSignal.style.transition = "opacity .5s ease-out";
        touchSignal.style.left = touch.x - 10 + "px";
        touchSignal.style.top = touch.y - 10 + "px";
        var element = fragment.appendChild(touchSignal);
        setTimeout(function () { return body.removeChild(element); }, 500);
        setTimeout(function () { return (element.style.opacity = "0"); }, 50);
    });
    document.body.appendChild(fragment);
}
function defaultCanTouch() {
    return true;
}
function getTouches(_a, points, radius, maybeDegrees) {
    var cx = _a[0], cy = _a[1];
    if (radius === void 0) { radius = 100; }
    var touches = [];
    if (points === 1) {
        return [{ x: cx, y: cy }];
    }
    var degrees = maybeDegrees ? (maybeDegrees * Math.PI) / 180 : 0;
    var slice = (2 * Math.PI) / points;
    for (var i = 0; i < points; i++) {
        var angle = slice * i + degrees;
        touches.push({
            x: cx + radius * Math.cos(angle),
            y: cy + radius * Math.sin(angle)
        });
    }
    return touches;
}
function toucher() {
    var document = window.document;
    var defaultTouchTypes = new Array(3).fill("tap").concat(new Array(1).fill("doubletap"), new Array(3).fill("gesture"), new Array(2).fill("multitouch"));
    var config = {
        touchTypes: defaultTouchTypes,
        positionSelector: defaultPositionSelector,
        showAction: defaultShowAction,
        canTouch: defaultCanTouch,
        maxNbTries: 10,
        logger: console,
        randomizer: null,
        maxTouches: 2
    };
    function defaultPositionSelector() {
        if (config.randomizer === null) {
            return [0, 0];
        }
        return [
            config.randomizer.natural({
                max: document.documentElement.clientWidth - 1
            }),
            config.randomizer.natural({
                max: document.documentElement.clientHeight - 1
            })
        ];
    }
    function triggerTouch(touches, element, type) {
        var touchlist = [];
        function item(index) {
            return this[index] || {};
        }
        touchlist.identifiedTouch = item;
        touchlist.item = item;
        touches.forEach(function (touch, i) {
            var x = Math.round(touch.x);
            var y = Math.round(touch.y);
            touchlist.push({
                pageX: x,
                pageY: y,
                clientX: x,
                clientY: y,
                screenX: x,
                screenY: y,
                target: element,
                identifier: i
            });
        });
        var event = document.createEvent("Event");
        event.initEvent("touch" + type, true, true);
        event.touches = type == "end" ? [] : touchlist;
        event.targetTouches = type == "end" ? [] : touchlist;
        event.changedTouches = touchlist;
        element.dispatchEvent(event);
        config.showAction(touches);
    }
    function triggerGesture(element, startPos, startTouches, gesture, done) {
        var interval = 10;
        var loops = Math.ceil(gesture.duration / interval);
        var loop = 1;
        function gestureLoop() {
            var _a = gesture.radius, radius = _a === void 0 ? 0 : _a, _b = gesture.scale, scale = _b === void 0 ? 0 : _b, _c = gesture.distanceX, distanceX = _c === void 0 ? 0 : _c, _d = gesture.distanceY, distanceY = _d === void 0 ? 0 : _d, _e = gesture.rotation, rotation = _e === void 0 ? null : _e;
            if (scale !== 1) {
                radius = radius - radius * (1 - scale) * ((1 / loops) * loop);
            }
            var posX = startPos[0] + (distanceX / loops) * loop;
            var posY = startPos[1] + (distanceY / loops) * loop;
            rotation = typeof rotation == "number" ? (rotation / loops) * loop : null;
            var touches = getTouches([posX, posY], startTouches.length, radius, rotation);
            var isFirst = loop == 1;
            var isLast = loop == loops;
            if (isFirst) {
                triggerTouch(touches, element, "start");
            }
            else if (isLast) {
                triggerTouch(touches, element, "end");
                return done(touches);
            }
            else {
                triggerTouch(touches, element, "move");
            }
            setTimeout(gestureLoop, interval);
            loop++;
        }
        gestureLoop();
    }
    var touchTypes = {
        tap: function (position, element, done) {
            var touches = getTouches(position, 1);
            var gesture = {
                duration: config.randomizer
                    ? config.randomizer.integer({ min: 20, max: 700 })
                    : 0
            };
            triggerTouch(touches, element, "start");
            setTimeout(function () {
                triggerTouch(touches, element, "end");
                done(touches, gesture);
            }, gesture.duration);
        },
        doubletap: function (position, element, done) {
            touchTypes.tap(position, element, function () {
                setTimeout(function () { return touchTypes.tap(position, element, done); }, 30);
            });
        },
        gesture: function (position, element, done) {
            var gesture = {
                distanceX: config.randomizer
                    ? config.randomizer.integer({ min: 0, max: 300 }) - 100
                    : 0,
                distanceY: config.randomizer
                    ? config.randomizer.integer({ min: 0, max: 300 }) - 100
                    : 0,
                duration: config.randomizer
                    ? config.randomizer.integer({ min: 20, max: 500 })
                    : 0
            };
            var touches = getTouches(position, 1, gesture.radius);
            triggerGesture(element, position, touches, gesture, function (touches) {
                return done(touches, gesture);
            });
        },
        multitouch: function (position, element, done) {
            var points = config.randomizer
                ? config.randomizer.integer({
                    min: 2,
                    max: config.maxTouches
                })
                : 0;
            var gesture = {
                scale: config.randomizer
                    ? config.randomizer.floating({ min: 0, max: 2 })
                    : 0,
                rotation: config.randomizer
                    ? config.randomizer.natural({ min: 0, max: 200 }) - 100
                    : 0,
                radius: config.randomizer
                    ? config.randomizer.integer({ min: 50, max: 200 })
                    : 0,
                distanceX: config.randomizer
                    ? config.randomizer.integer({ min: 0, max: 40 }) - 20
                    : 0,
                distanceY: config.randomizer
                    ? config.randomizer.integer({ min: 0, max: 40 }) - 20
                    : 0,
                duration: config.randomizer
                    ? config.randomizer.integer({ min: 100, max: 1500 })
                    : 0
            };
            var touches = getTouches(position, points, gesture.radius);
            triggerGesture(element, position, touches, gesture, function (touches) {
                return done(touches, gesture);
            });
        }
    };
    function toucherGremlin(done) {
        var _a;
        if (!config.randomizer) {
            throw new exceptions_1.RandomizerRequiredException();
        }
        var posX;
        var posY;
        var targetElement;
        var nbTries = 0;
        do {
            _a = config.positionSelector(), posX = _a[0], posY = _a[1];
            targetElement = document.elementFromPoint(posX, posY);
            nbTries++;
            if (nbTries > config.maxNbTries) {
                return;
            }
        } while (!targetElement || !config.canTouch(targetElement));
        var touchType = config.randomizer.pick(config.touchTypes);
        if (!(touchType in touchTypes)) {
            throw new Error("Invalid touch type \"" + touchType + "\"");
        }
        touchTypes[touchType]([posX, posY], targetElement, logGremlin);
        function logGremlin(touches, details) {
            if (typeof config.showAction === "function") {
                config.showAction(touches);
            }
            if (config.logger && typeof config.logger.log === "function") {
                config.logger.log("gremlin", "toucher   ", touchType, "at", posX, posY, details);
            }
            if (done) {
                done();
            }
        }
    }
    utils_1.configurable(toucherGremlin, config);
    return toucherGremlin;
}
exports.toucher = toucher;
